import { HttpErrorResponse } from '@angular/common/http';
import { IAccountingBasisExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { EntityState } from '@ngrx/entity';

export interface IAccountingBasisState extends EntityState<IAccountingBasisExtendedDTO> {
    activeAccountingBasis?: IAccountingBasisExtendedDTO;
    error?: HttpErrorResponse;
}
